import {
  DATA_TABLE_SOURCE_ADMIN_TOURS,
  DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED,
  DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR,
  DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED_INDICATOR,
  DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNASKED,
  DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNANSWERED,
} from 'common/dataTableConstants';

import {
  TOUR_STATUS_REQUESTED,
  TOUR_STATUS_SCHEDULED,
  TOUR_STATUS_COMPLETED,
} from 'common/tourConstants';

import {
  actionInitializeDataTableState,
  actionDataTableLoadNextPage,
} from 'client/helpers/dataTables';

export default async function getItemsForToursIndicators({ state, apiClient }) {
  await Promise.all([
    actionInitializeDataTableState(
      { state },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED,
        sort: {
          'tours.startDate': 'asc',
        },
        filter: {
          'tours.status': TOUR_STATUS_REQUESTED,
          'tours.markedNeedsReschedulingFlag': false,
        },
        customParams: {
          tourDashboard: {
            unread: true,
          },
        },
      },
    ),
    actionInitializeDataTableState(
      { state },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR,
        sort: {
          'tours.startDate': 'asc',
        },
        filter: {
          'tours.status': TOUR_STATUS_SCHEDULED,
        },
        customParams: {
          tourDashboard: {
            unread: true,
          },
        },
      },
    ),
    actionInitializeDataTableState(
      { state },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED_INDICATOR,
        sort: {
          'tours.startDate': 'asc',
        },
        filter: {
          'tours.status': TOUR_STATUS_SCHEDULED,
          'tours.agentUserId': null,
        },
        customParams: {
          tourDashboard: {
            unassigned: true,
          },
        },
      },
    ),
    actionInitializeDataTableState(
      { state },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNASKED,
        sort: {
          'tours.lastStatusUpdateDate': 'desc',
        },
        filter: {
          'tours.status': TOUR_STATUS_COMPLETED,
        },
        customParams: {
          tourDashboard: {
            unaskedQuestion: true,
          },
        },
      },
    ),
    actionInitializeDataTableState(
      { state },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNANSWERED,
        sort: {
          'tours.lastStatusUpdateDate': 'desc',
        },
        filter: {
          'tours.status': TOUR_STATUS_COMPLETED,
        },
        customParams: {
          tourDashboard: {
            unansweredQuestion: true,
          },
        },
      },
    ),
  ]);

  return Promise.all([
    actionDataTableLoadNextPage(
      { state, apiClient },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED,
        count: 1,
      },
    ),
    actionDataTableLoadNextPage(
      { state, apiClient },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR,
        count: 1,
      },
    ),
    actionDataTableLoadNextPage(
      { state, apiClient },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED_INDICATOR,
        count: 1,
      },
    ),
    actionDataTableLoadNextPage(
      { state, apiClient },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNASKED,
        count: 1,
      },
    ),
    actionDataTableLoadNextPage(
      { state, apiClient },
      {
        dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
        viewId: DATA_TABLE_VIEW_ID_ADMIN_TOURS_COMPLETED_QUESTION_UNANSWERED,
        count: 1,
      },
    ),
  ]);
}
